import { baseSiteEndPoint, buildHeaders, getSellerID, urlFilters } from "./common";
import { authorizedFetch } from "./login";

export const apiSalesByDate = async (filters, accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/salesbydate/`, filters), 
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiReceivablesByDate = async (filters, accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/receivablesbydate/`, filters), 
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiProductByDate = async (filters, accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/productbydate/`, filters), 
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const apiAccountSalesComparison = async (filters, accountId = null) => {
  try {
    const sellerId = accountId || getSellerID();
    const response = await authorizedFetch(
      urlFilters(`${baseSiteEndPoint}/unified/accounts/sellers/${sellerId}/metrics/accountsalescomparison/`, filters), 
      {
        method: "GET",
        headers: buildHeaders(),
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};
